import { getDaysBetween, getRelativeDuration } from '@/utils/formatDate'

/**
 * This gives the relative duration to be shown beside initiative date type field's value
 * @param date
 * @returns {string|null}
 */
export default date => {
  if (!date) return null
  const today = new Date()
  const daysDiff = Math.abs(getDaysBetween(new Date(date), today))
  return daysDiff > 0 && daysDiff <= 14 ? getRelativeDuration(date) : null
}
